import React from 'react'
import { useTranslation } from 'react-i18next'
import { graphql, useStaticQuery } from 'gatsby'
import Number from './number'
import RichContent from '../../uielements/RichContent/richContent'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Wrapper from '../../components/Wrapper'
import Spacer from '../../uielements/Spacer'
import InnerTitle from '../../uielements/InnerTitle'
import { theme } from '../../theme/theme'

const Numbers = () => {
    const { i18n } = useTranslation()

    const registrations = useStaticQuery(
        graphql`
            query FetchAllNumbers {
                allContentfulNumbersOverview {
                    nodes {
                        id
                        title
                        node_locale
                        excerpt {
                            raw
                        }
                        icon {
                            url
                            title
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 1920
                                width: 1920
                                quality: 75
                                sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                                layout: FULL_WIDTH
                                breakpoints: [576, 768, 960, 1200, 1920]
                            )
                        }
                    }
                }
            }
        `
    )

    const items = registrations.allContentfulNumbersOverview.nodes

    const settings = {
        dots: true,
        slidesToScroll: 1,
        centerMode: false,
        infinite: true,
        slidesToShow: 4,
        speed: 500,
        arrows: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    centerMode: false,
                    dots: true,
                    arrows: false,
                    centerPadding: '0',
                },
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerPadding: '0',
                },
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '0',
                },
            },
        ],
    }

    return (
        <Wrapper>
            <Spacer top="14" />
            <Wrapper>
                <InnerTitle title="ΣΧΟΛΕΙΟ ΣΕ ΑΡΙΘΜΟΥΣ" mainColor={theme.blue} secColor={theme.lightBlue} />
            </Wrapper>
            <Spacer top="8" />
            <Slider {...settings}>
                {items.map(
                    (item) =>
                        item.node_locale === i18n.language && (
                            <Number key={item.id} icon={item.icon} title={item.title}>
                                <RichContent body={item.excerpt} locale={i18n.language} />
                            </Number>
                        )
                )}
            </Slider>
            <Spacer top="20" />
        </Wrapper>
    )
}

export default Numbers
